<template>
    <div>
        <div class="simple-row">
            <div class="right">
                <button class="swb-btn swb-btn-small swb-btn-primary" v-if="!showDetail" @click="setQuantity()">批量设置服务次数</button>
            </div>
        </div>
        <el-table :data="orgQuantityList" border style="width: 100%" height="565">
            <el-table-column type="index" label="行号" align="center" width="50"></el-table-column>
            <el-table-column prop="bizUnitName" label="业务单元" width="180" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bizAreaName" label="经营区域" width="180" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bizFormName" label="经营业态" align="left"></el-table-column>
            <el-table-column prop="mgmtSmlAreaName" label="管理区域" align="left"></el-table-column>
            <el-table-column prop="quantity" label="服务次数" align="left">
                <template slot-scope="rows">
                    <el-input type="number" :min="0" v-model.number="rows.row.quantity" :disabled="showDetail"></el-input>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { MsgBox, Vue } from '../../app.vues'
import SwbPropEditor from '../ctrl/PropEditor.vue';

Vue.regist(SwbPropEditor);

export default {
    name: 'swb-contract-servc-org-quantity-list',
    desc: '合同服务门店次数',
    props: ['selectComList', 'showDetail'],
    data: function () {
        return {
            orgQuantityList: [],
        }
    },
    created: function () {
        let selectComList = this.selectComList || [];
        if(selectComList.length > 0) {
            for(let i = 0; i < selectComList.length; i++) {
                let comInfo = selectComList[i];
                if(Utils.isNoB(comInfo.quantity)) {
                    comInfo.quantity = 0;
                }
            }
            this.orgQuantityList = Utils.merge([], selectComList);
        }
    },
    methods: {
        setQuantity: function () {
            let self = this;
            let orgQuantityList = this.orgQuantityList || [];
            if(orgQuantityList.length <= 0) {
                MsgBox.warning("请先设置特定门店");
                return false;
            }
            let validatorFunc = function (code, value, label, valuesMap) {
                if(value < 0) {
                    return "数量不可小于0";
                }
            }
            let theDlg = Vue.$showDialog({
                title: "设置服务次数",
                showCloseBtn: true,
                width: 500,
                height: 300,
                template: '<swb-prop-editor ref="prop_editor" :title="editorTitle" :noGrid="true" :showBtnBar="false" :width="430" :widthForLabel="120" :propList="propList" :viewMode="false" :readOnly="false"></swb-prop-editor>',
                data: {
                    editorTitle: "",
                    propList: [{
                        label: '设置服务次数', code: 'quantity', value: 0, valueType: 'Integer', tooltip: '', required: true, width: 300, validator: validatorFunc
                    }]
                },
                okClicked: function () {
                    let propEditor = this.$refs['prop_editor'];
                    if(propEditor.validate()) {
                        let postData = propEditor.getPropValues();
                        for(let i = 0; i < orgQuantityList.length; i++) {
                            let orgQuantityInfo = orgQuantityList[i];
                            orgQuantityInfo.quantity = postData.quantity;
                        }
                        self.orgQuantityList = Utils.merge([], orgQuantityList);
                        theDlg.close();
                    }
                    return false;
                }
            });
        },
        getDlgResult: function () {
            return {
                type: 'info',
                data: this.orgQuantityList || []
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractServcOrgQuantityList.vue